import { IUser, IWorkspace } from "../../../types/reducers/authReducer";
import { InferActionsTypes } from "./../index";

export const actionTypes = {
  LOGIN_USER_TRIGGER: "LOGIN_USER_TRIGGER",
  REG_USER_TRIGGER: "REG_USER_TRIGGER",
  LOGOUT_TRIGGER: "LOGOUT_TRIGGER",
  GET_TOKEN_TRIGGER: "GET_TOKEN_TRIGGER",
  LOGIN_USER: "LOGIN_USER",
  LOGOUT: "LOGOUT",
  SET_PENDING_LOGOUT_WARNING: "SET_PENDING_LOGOUT_WARNING",
  REG_USER: "REG_USER",
  GET_USER: "GET_USER",
  GET_USER_SUCCESS: "GET_USER_SUCCESS",
  GET_USER_ERROR: "GET_USER_ERROR",
  SET_USER_TOKEN: "SET_USER_TOKEN",
  GET_TOKEN: "GET_TOKEN",
  GET_TOKEN_FOR_SOCKET_CONNECTION: "GET_TOKEN_FOR_SOCKET_CONNECTION",
  GET_TOKEN_FOR_SOCKET_CONNECTION_SUCCESS: "GET_TOKEN_FOR_SOCKET_CONNECTION_SUCCESS",
  GET_TOKEN_FOR_SOCKET_CONNECTION_ERROR: "GET_TOKEN_FOR_SOCKET_CONNECTION_ERROR",
  FORGET_PASSWORD: "FORGET_PASSWORD",
  FORGET_PASSWORD_SUCCESS: "FORGET_PASSWORD_SUCCESS",
  FORGET_PASSWORD_ERROR: "FORGET_PASSWORD_ERROR",
  RESET_PASSWORD: "RESET_PASSWORD",
  RESET_PASSWORD_SUCCESS: "RESET_PASSWORD_SUCCESS",
  RESET_PASSWORD_ERROR: "RESET_PASSWORD_ERROR",
  CHANGE_USER_LANGUAGE: "CHANGE_USER_LANGUAGE",
  CHANGE_USER_LANGUAGE_SUCCESS: "CHANGE_USER_LANGUAGE_SUCCESS",
  CHANGE_USER_LANGUAGE_ERROR: "CHANGE_USER_LANGUAGE_ERROR",
  TOKEN_LOGIN_USER_TRIGGER: "TOKEN_LOGIN_USER_TRIGGER",
  LINK_LOGIN_USER_TRIGGER: "LINK_LOGIN_USER_TRIGGER",
  SEND_LOGIN_LINK_SUCCESS: 'SEND_LOGIN_LINK_SUCCESS',
  SEND_LOGIN_LINK_FAILURE: 'SEND_LOGIN_LINK_FAILURE',
  RESET_LOGIN_LINK_DATA:'RESET_LOGIN_LINK_DATA',
  REG_USER_START: 'REG_USER_START',
  REG_USER_END: 'REG_USER_END',
  SET_WORKSPACE_FROM_AUTH: 'SET_WORKSPACE_FROM_AUTH',
  UPDATE_WORKSPACE_SETTINGS: 'UPDATE_WORKSPACE_SETTINGS',
  UPDATE_WORKSPACE_SETTINGS_SUCCESS: 'UPDATE_WORKSPACE_SETTINGS_SUCCESS',
  UPDATE_WORKSPACE_SETTINGS_ERROR: 'UPDATE_WORKSPACE_SETTINGS_ERROR',
  UPDATE_SUPPORT_ACCESS: 'UPDATE_SUPPORT_ACCESS',
  UPDATE_SUPPORT_ACCESS_SUCCESS: 'UPDATE_SUPPORT_ACCESS_SUCCESS',
  UPDATE_SUPPORT_ACCESS_ERROR: 'UPDATE_SUPPORT_ACCESS_ERROR',
  UPDATE_PASSWORD: 'UPDATE_PASSWORD',
  UPDATE_PASSWORD_SUCCESS: 'UPDATE_PASSWORD_SUCCESS',
  UPDATE_PASSWORD_ERROR: 'UPDATE_PASSWORD_ERROR',
  SET_PASSWORD_MODAL_OPEN: 'SET_PASSWORD_MODAL_OPEN',
  SET_PASSWORD_MODAL_CLOSE: 'SET_PASSWORD_MODAL_CLOSE',
  SET_LOGIN_ERROR: 'SET_LOGIN_ERROR',
};

interface InitialState {
  token: string | null;
  user: IUser | null;
  currentUser: IUser | null;
  loginLinkData  :any | null
  registering: boolean;
  workspace: IWorkspace | null;
  workspaceSettingsSaving: boolean;
  supportAccessSaving: boolean;
  passwordSaving: boolean;
  passwordError: string | null;
  showSetPasswordModal: boolean;
  /** Public v3 (P2.3): why the last sign-in failed, for the form to word in both languages. */
  loginError: { kind: "mismatch" } | { kind: "throttle"; seconds: number } | null;
  /** Count of unsynced offline writes holding up a logout, or null when nothing is. */
  pendingLogoutWarning: number | null;
}

const initialState: InitialState = {
  token: null,
  user: null,
  currentUser: null,
  loginLinkData: null,
  registering: false,
  workspace: null,
  workspaceSettingsSaving: false,
  supportAccessSaving: false,
  passwordSaving: false,
  passwordError: null,
  showSetPasswordModal: false,
  loginError: null,
  // Number of unsynced offline writes blocking a logout, or null when not blocking.
  pendingLogoutWarning: null,
};

export const authReducer = (state = initialState, action: Actions) => {
  switch (action.type) {
    case actionTypes.SET_PENDING_LOGOUT_WARNING:
      return { ...state, pendingLogoutWarning: action.payload };
    case actionTypes.SET_USER_TOKEN:
      return { ...state, token: action.payload };
    case actionTypes.LOGIN_USER:
      return { ...state, user: action.payload };
    case actionTypes.GET_USER_SUCCESS:
      return { ...state, currentUser: action.payload };
    case actionTypes.SEND_LOGIN_LINK_SUCCESS:
      return { ...state, loading: false,loginLinkData: action.payload };
      case actionTypes.RESET_LOGIN_LINK_DATA:
      return {
        ...state,
        loginLinkData: null,
      };
    case actionTypes.REG_USER_START:
      return { ...state, registering: true };
    case actionTypes.REG_USER_END:
      return { ...state, registering: false };
    case actionTypes.SET_WORKSPACE_FROM_AUTH:
      return { ...state, workspace: action.payload };
    case actionTypes.UPDATE_WORKSPACE_SETTINGS:
      return { ...state, workspaceSettingsSaving: true };
    case actionTypes.UPDATE_WORKSPACE_SETTINGS_SUCCESS:
      return { ...state, workspaceSettingsSaving: false, workspace: action.payload };
    case actionTypes.UPDATE_WORKSPACE_SETTINGS_ERROR:
      return { ...state, workspaceSettingsSaving: false };
    case actionTypes.UPDATE_SUPPORT_ACCESS:
      return { ...state, supportAccessSaving: true };
    case actionTypes.UPDATE_SUPPORT_ACCESS_SUCCESS:
      return {
        ...state,
        supportAccessSaving: false,
        currentUser: state.currentUser
          ? { ...state.currentUser, support_access_approved: action.payload }
          : state.currentUser,
      };
    case actionTypes.UPDATE_SUPPORT_ACCESS_ERROR:
      return { ...state, supportAccessSaving: false };
    case actionTypes.UPDATE_PASSWORD:
      return { ...state, passwordSaving: true, passwordError: null };
    case actionTypes.UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        passwordSaving: false,
        showSetPasswordModal: false,
        currentUser: state.currentUser ? { ...state.currentUser, has_password: true } : state.currentUser,
      };
    case actionTypes.UPDATE_PASSWORD_ERROR:
      return { ...state, passwordSaving: false, passwordError: action.payload };
    case actionTypes.SET_PASSWORD_MODAL_OPEN:
      return { ...state, showSetPasswordModal: true };
    case actionTypes.SET_LOGIN_ERROR:
      return { ...state, loginError: action.payload ?? null };
    case actionTypes.LOGIN_USER_TRIGGER:
      return { ...state, loginError: null };
    case actionTypes.SET_PASSWORD_MODAL_CLOSE:
      return { ...state, showSetPasswordModal: false };
    default:
      return state;
  }
};

export const actions = {
  loginUserAC: (data: IUser | null) => ({
    type: actionTypes.LOGIN_USER,
    payload: data,
  }),
  setUser: (data: IUser | null) => ({
    type: actionTypes.GET_USER_SUCCESS,
    payload: data,
  }),
  sendLoginLinkSuccess: (data: any) => ({
    type: actionTypes.SEND_LOGIN_LINK_SUCCESS,
    payload: data,
  })
};

export const authWorkspaceActions = {
  updateWorkspaceSettings: (payload: Partial<IWorkspace>) => ({
    type: actionTypes.UPDATE_WORKSPACE_SETTINGS,
    payload,
  }),
};

export const authSupportAccessActions = {
  updateSupportAccess: (payload: { support_access_approved: boolean }) => ({
    type: actionTypes.UPDATE_SUPPORT_ACCESS,
    payload,
  }),
};

export const authPasswordActions = {
  updatePassword: (payload: {
    password: string;
    password_confirmation: string;
    // Omitted for accounts that have no password yet (magic-link sign-ups).
    current_password?: string;
  }) => ({
    type: actionTypes.UPDATE_PASSWORD,
    payload,
  }),
  closeSetPasswordModal: () => ({
    type: actionTypes.SET_PASSWORD_MODAL_CLOSE,
  }),
};

export const authTriggerActions = {
  loginUserTriggerAC: (data: any) => ({
    type: actionTypes.LOGIN_USER_TRIGGER,
    data,
  }),
  regUserTriggerAC: (data: any) => ({
    type: actionTypes.REG_USER_TRIGGER,
    data,
  }),
  // force=true is what the unsynced-changes dialog sends back to proceed anyway.
  // `then` (Public v3, "Continue as X"): after the normal sign-out, sign in with this one-time link instead of going to /login.
  logoutUserTriggerAC: (force = false, then?: { email: string; token: string; workspace_id?: string | null; open?: string | null; next?: string | null }) => ({
    type: actionTypes.LOGOUT_TRIGGER,
    force,
    ...(then ? { then } : {}),
  }),
  setPendingLogoutWarningAC: (count: number | null) => ({
    type: actionTypes.SET_PENDING_LOGOUT_WARNING,
    payload: count,
  }),
  getTokenTriggerAC: () => ({
    type: actionTypes.GET_TOKEN_TRIGGER,
  }),
  tokenLoginUserTriggerAC: (data: { email: string; token: string; workspace_id?: string | null; open?: string | null; next?: string | null }) => ({
    type: actionTypes.TOKEN_LOGIN_USER_TRIGGER,
    data,
  }),
  linkLoginUserTriggerAC: (email: string) => ({
    type: actionTypes.LINK_LOGIN_USER_TRIGGER,
    email,
  }),
};

export type Actions = InferActionsTypes<typeof actions> | { type: string; payload?: any };
